import PropTypes from 'prop-types'
import React, {useId, useMemo} from 'react'
import {FormattedMessage} from 'react-intl'
import Checkbox from '../checkbox'
import Link from '../link'
import {Text} from '@chakra-ui/react'

const MarketingOptIn = ({testid, value, onChange, viewExtendedDescription, isRequired}) => {
    onChange = onChange || ((newValue) => (value = newValue))
    const isError = useMemo(() => {
        return Boolean(!value)
    }, [value])

    const fieldId = useId()
    const errorId = `${fieldId}-error`
    return (
        <Checkbox
            size="sm"
            name="marketingOptIn"
            isChecked={value}
            data-testid={testid}
            onChange={(e) => {
                onChange(e.target.checked)
            }}
            {...(isRequired ? {required: true} : {})}
            aria-invalid={isError || undefined}
            aria-describedby={isError ? errorId : undefined}
        >
            {!viewExtendedDescription && (
                <FormattedMessage
                    defaultMessage="Yes, I would like personalized emails about exclusive content, product recommendations and promotional updates from Stokke Group (Stokke AS and its subsidiaries) based on my profile data, purchase history and activities in Stokke digital channels. Unsubscribe link in every newsletter and in MyAccount. What personal data we process, why and how: {privacy}."
                    id="forms.marketing"
                    values={{
                        privacy: (
                            <Link
                                href="/customer-service/legal/privacy-policy.html"
                                isExternal
                                size="sm"
                            >
                                <FormattedMessage
                                    defaultMessage="Privacy Policy"
                                    id="footer.link.privacy_policy"
                                />
                            </Link>
                        )
                    }}
                />
            )}
            {viewExtendedDescription && (
                <FormattedMessage
                    defaultMessage="Yes, I would like personalized emails about exclusive content, product recommendations and promotional updates from Stokke Group (Stokke AS and its subsidiaries) based on my profile data, purchase history and activities in Stokke digital channels. Unsubscribe link in every newsletter and in MyAccount. What personal data we process, why and how: {privacy}."
                    id="forms.marketing2"
                    values={{
                        privacy: (
                            <Link
                                href="/customer-service/legal/privacy-policy.html"
                                isExternal
                                fontSize="inherit"
                            >
                                <FormattedMessage
                                    defaultMessage="Privacy Policy"
                                    id="footer.link.privacy_policy"
                                />
                            </Link>
                        )
                    }}
                />
            )}
            {isRequired && <span>*</span>}
            {isRequired && isError && (
                <Text color="stokkeFunctional.alertRed" mt={2} role="alert" id={errorId}>
                    <FormattedMessage
                        defaultMessage="Please accept the Terms and Conditions"
                        id="forms.marketing.accept_terms_conditions"
                    />
                </Text>
            )}
        </Checkbox>
    )
}

MarketingOptIn.propTypes = {
    testid: PropTypes.string,
    value: PropTypes.bool,
    viewExtendedDescription: PropTypes.bool,
    onChange: PropTypes.func,
    isRequired: PropTypes.bool
}

export default MarketingOptIn
